module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sample":"Sample","save":"Save","organize":"Organize","delete":"Delete","rename":"Rename","schema_browser":"Schema Browser","job_list":"Job List"},"ja":{"sample":"例","save":"保存","organize":"整理","delete":"削除","rename":"改名","schema_browser":"Schema Browser","job_list":"ジョブ一覧"}}')
  delete Component.options._Ctor
}
